import { render } from "./AddressComponent.vue?vue&type=template&id=f70a0ee6&scoped=true"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"

import "./AddressComponent.vue?vue&type=style&index=0&id=f70a0ee6&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70a0ee6"]])

export default __exports__